// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'f33b08b4542612350fbed54e1fdaa235176364ff';
export const BUILD_NUMBER = '219';
export const BUILD_TIMESTAMP = '2026-08-21T01:51:51.853Z';
